import React, { useRef } from "react";
import { Offcanvas } from "react-bootstrap";
import { createPortal } from "react-dom";
import { useOnClickOutside } from "usehooks-ts";

import { BurgerIcon } from "../icons";
import { SidebarNav } from "./SidebarNav";

interface IProps {
  openMobileSidebar: () => void;
  closeMobileSidebar: () => void;
  showMobileSidebar: boolean;
  showUsageLink?: boolean;
  isOwner?: boolean;
  hideItems?: boolean;
}

const MobileSidebar: React.FC<IProps> = ({
  openMobileSidebar,
  closeMobileSidebar,
  showMobileSidebar,
  showUsageLink,
  isOwner,
  hideItems,
}) => {
  const burgerButtonRef = useRef<HTMLDivElement>(null);
  const burgerContainer = document.getElementById("burger-container");
  useOnClickOutside([burgerButtonRef], () => {
    closeMobileSidebar();
  });
  const toggleSideBar = () => {
    if (showMobileSidebar) {
      closeMobileSidebar();
    } else {
      openMobileSidebar();
    }
  };
  return (
    burgerContainer &&
    createPortal(
      <div className="react-sidebar react-sidebar--mobile d-flex">
        <div className="d-flex align-items-center " title="Show sidebar menu">
          <div
            onClick={toggleSideBar}
            role="button"
            className="toggle-sidebar-btn"
            ref={burgerButtonRef}
          >
            <BurgerIcon />
          </div>
        </div>
        <Offcanvas
          show={showMobileSidebar}
          onHide={closeMobileSidebar}
          className="react-sidebar--mobile__nav-container"
          backdropClassName="react-sidebar-backdrop"
        >
          <Offcanvas.Body className="sidebar-nav-container p-0">
            <SidebarNav
              hideItems={hideItems}
              showUsageLink={showUsageLink}
              isOwner={isOwner}
            />
          </Offcanvas.Body>
        </Offcanvas>
      </div>,
      burgerContainer,
    )
  );
};
export { MobileSidebar };
